import React from "react";
import ChevronRightIcon from "@heroicons/react/20/solid/ChevronRightIcon";

import cx from "@hsl/core/utils/cx";
import twColors from "@hsl/lgim/src/js/lib/themeColors";

export interface Tab {
    key: string;
    label: React.ReactNode;
}

export interface TabProps {
    tab: Tab;
    className?: string;
    current?: boolean;
    onClick?(): void;
    variant: "default" | "blue" | "radio";
}
const Tab = ({ tab, className, current, onClick, variant }: TabProps) => {
    const { label } = tab;
    const handleClick: React.MouseEventHandler<
        HTMLButtonElement | HTMLAnchorElement
    > = (e) => {
        e.stopPropagation();
        !!onClick && onClick();
    };

    return (
        <button
            className={cx(
                { "font-medium": current && variant !== "radio" },
                "group flex w-full items-center justify-between border-b border-gray-100 py-1 text-sm transition",
                variant === "blue" && [
                    "py-2.5 text-left text-base first:pt-0",
                    current && "text-core-blue border-core-blue border-b-2",
                ],
                variant === "radio" && [
                    "border-0 py-1.5",
                    current && "text-core-blue",
                ],
                className,
            )}
            onClick={handleClick}
        >
            <span
                className={cx({
                    "pr-12": variant === "default",
                    "inline-flex w-full items-center": variant === "radio",
                })}
            >
                {variant === "radio" && (
                    <input
                        type="radio"
                        className="pointer-events-none mr-2"
                        checked={current}
                        readOnly
                    />
                )}
                {label}
            </span>
            {variant === "default" && (
                <ChevronRightIcon
                    width={18}
                    height={18}
                    color={twColors["battleship-grey"]}
                    className={cx({
                        "opacity-0 transition-transform delay-100 group-hover:translate-x-px group-hover:opacity-100":
                            !current,
                        block: current,
                    })}
                />
            )}
        </button>
    );
};

export default Tab;
